<template>
  <v-card :loading="loading" class="px-2">
    <v-card-title>{{ title }}</v-card-title>
    <v-card-subtitle>
      {{ subtitle }}
    </v-card-subtitle>
    <v-card-text>
      <activity-timeline
        :activities="activities"
        :type="type"
      ></activity-timeline>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import ActivityTimeline from "@/components/common/ActivityTimeline";
export default {
  name: "Activities",
  components: {
    ActivityTimeline
  },
  props: { id: { type: String }, typeId: { type: Number } },
  data: () => ({ loading: false }),
  computed: {
    title() {
      switch (this.typeId) {
        case this.$enums.coreCardIdTypes.MEMBER:
          return "Member Activity Feed";
        case this.$enums.coreCardIdTypes.TEAM:
          return "Department Activity Feed";
        case this.$enums.coreCardIdTypes.MANAGER:
          return "Team Activity Feed";
        case this.$enums.coreCardIdTypes.CORE_VALUE:
          return this.id
            ? `${this.t("core_values.title_s")} Activity Feed`
            : `${this.t("mission.title")} Statement Activity Feed`;
      }
      return "";
    },
    subtitle() {
      switch (this.typeId) {
        case this.$enums.coreCardIdTypes.MEMBER:
          return `A timeline of activities for ${this.user.firstName ||
            this.user.email}`;
        case this.$enums.coreCardIdTypes.TEAM:
          return "A timeline of activity for this department";
        case this.$enums.coreCardIdTypes.MANAGER:
          return "A timeline of activity for this team";
        case this.$enums.coreCardIdTypes.CORE_VALUE:
          return this.id
            ? `A timeline of activity for this ${this.t(
                "core_values.title_s",
                true
              )}`
            : `A timeline of activity for your ${this.t(
                "mission.title",
                true
              )} statement`;
      }
      return "";
    },
    type() {
      switch (this.typeId) {
        case this.$enums.coreCardIdTypes.MEMBER:
          return "Member";
        case this.$enums.coreCardIdTypes.TEAM:
          return "Team";
        case this.$enums.coreCardIdTypes.MANAGER:
          return "Manager";
        case this.$enums.coreCardIdTypes.CORE_VALUE:
          return this.id ? "CoreValue" : "MissionStatement";
      }
      return "";
    },
    getAction() {
      switch (this.typeId) {
        case this.$enums.coreCardIdTypes.MEMBER:
          return "user/getActivities";
        case this.$enums.coreCardIdTypes.TEAM:
          return "team/getActivities";
        case this.$enums.coreCardIdTypes.MANAGER:
          return "user/getManagerActivities";
        case this.$enums.coreCardIdTypes.CORE_VALUE:
          return this.id
            ? "company/getCoreValueActivities"
            : "company/getMissionStatementActivities";
      }
      return "";
    },
    getter() {
      switch (this.typeId) {
        case this.$enums.coreCardIdTypes.MEMBER:
          return "user/activities";
        case this.$enums.coreCardIdTypes.TEAM:
          return "team/activities";
        case this.$enums.coreCardIdTypes.MANAGER:
          return "user/activities";
        case this.$enums.coreCardIdTypes.CORE_VALUE:
          return this.id
            ? "company/corevalue_activities"
            : "company/missionstatement_activities";
      }
      return "";
    },
    activities() {
      if (!this.getter) {
        return [];
      }
      return this.$store.getters[this.getter];
    },
    ...mapGetters({
      user: "user/edit_user"
    })
  },
  created() {
    this.loading = true;
    this.$store
      .dispatch(this.getAction, this.id)
      .catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while loading activities."
        );
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {}
};
</script>
